import { cloneElement, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { cn } from '@/Domain/utils/cn';

type Props = {
  pathMatch: (pathname: string) => boolean;
  component: JSX.Element;
  zIndex?: number;
  className?: string;
};

export const KeepAliveRenderer = ({ pathMatch, component, className }: Props) => {
  const location = useLocation();

  const show = pathMatch(location.pathname);
  const cached = useRef<JSX.Element | null>(null);

  // Arm the cache only on first visit: mounting on every route would run the
  // page's queries/effects (and any paid side effects) for users who never open it.
  if (!cached.current && show) {
    cached.current = component;
  }

  // display:contents so the kept-alive page is a direct flex child (a real box breaks full-bleed -m-6 pages).
  return (
    <div
      className={cn('h-full', className)}
      style={{
        display: show ? 'contents' : 'none',
      }}
    >
      {cached.current && cloneElement(cached.current, { isActive: show })}
    </div>
  );
};
